import { useEffect } from 'react';
import { useHeaderActions } from './HeaderContext';

const HeaderLoader = () => {
  const { initializeState } = useHeaderActions();

  useEffect(() => {
    initializeState();
  }, []);

  return null;
};

export default HeaderLoader;
